import { CommonModule } from '@angular/common';
import { Component,  Input } from '@angular/core';

@Component({
    selector: 'grey-wrapper',
    template: `
<div class="wrapper">
  <div class="grey-wrapper" [ngClass]="{noBottom: !!bottomHeight}">
    <ng-content></ng-content>
  </div>
  <div *ngIf="!!bottomHeight" class="grey-bottom" [ngStyle]="{height: bottomHeight}">
    <ng-content select=".bottom"></ng-content>
  </div>
</div>
`,
    styleUrls: ['./grey-wrapper.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class GreyWrapperComponent {
  @Input() bottomHeight: string | null = null
}

